module.exports = __webpack_public_path__ + "img/logo-om.8293cc14.png";